"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheEntry = void 0;
const guard_1 = require("../utils/guard");
/**
 * A entry for the a cache.
 */
class CacheEntry {
    /**
     * Initializes a new instance of the @see CacheEntry class.
     * @param key Key of the cache entry.
     * @param value Value of the cache entry.
     * @param expiration Expiraiton date for cache entry.
     */
    constructor(key, value, expiration) {
        guard_1.Guard.throwIfNullOrEmpty(key, 'key');
        guard_1.Guard.throwIfNullOrEmpty(value, 'value');
        guard_1.Guard.throwIfNullOrEmpty(expiration, 'expiration');
        this.expiration = expiration;
        this.key = key;
        this.value = value;
    }
}
exports.CacheEntry = CacheEntry;
//# sourceMappingURL=cacheEntry.js.map